import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import LoginForm from './Layout/LoginForm';
import Wrapper from './Layout/Wrapper';

class Login extends Component{

    render(){
        const { alert: { login } } = this.props;
        return (
            <Wrapper>
                {login !== false && 
                    <Alert color={login.type}>{login.message}</Alert>    
                }
                {login !== false && login.type === 'success' && <Redirect to='dashboard' />}
                <LoginForm/>
            </Wrapper>
        );
    }
}

const mapStateToProps = (state) => ({
    alert: state.auth.alert,
});

export default connect(mapStateToProps)(Login);


// WEBPACK FOOTER //
// ./src/Components/Auth/Login.js